import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {Machines} from "../../Machines";
import {NavigationProps, WizardNavigation} from "../../../_shared/wizard/WizardNavigation";
import React, {Fragment, useState} from "react";
import {Machine} from "../../../../models/machine.models";
import Checkbox from "@material-ui/core/Checkbox";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2),
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    selectedCount: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    }
}));

interface Props extends NavigationProps {
    onChangeMachineSelection: (selectedMachines: Map<string, Machine>) => void,
    organizationId: number
}

export const Step1Selection: React.FC<Props> = ({organizationId, onChangeMachineSelection, ...props}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const [selectedMachines, setSelectedMachines] = useState<Map<string, Machine>>(new Map());

    const actions = (o: any) => <Checkbox
        checked={selectedMachines && selectedMachines.has(o.id)}
        onChange={e => onMachineSelected(o, e)}
        color="primary"
        inputProps={{'aria-label': 'primary checkbox'}}
    />;

    const updateMachineSelected = (oldSet: Map<string, Machine>, machine: Machine, checked: boolean): Map<string, Machine> => {
        const newSet = new Map(oldSet);
        if (checked) newSet.set(machine.id, machine);
        else if (!checked && newSet.has(machine.id)) newSet.delete(machine.id);
        return newSet;
    }

    const onMachineSelected = (o: Machine, e: any) => {
        const checked = e.target.checked;
        setSelectedMachines(oldSet => updateMachineSelected(oldSet, o, checked));
    }

    const onSubmitChange = (changeTab: () => void) => {
        onChangeMachineSelection(selectedMachines);
        changeTab();
    }

    return <Fragment>
        <Grid item xs={12} className={classes.selectedCount}>
            <Typography variant="subtitle1">
                {t('Machine.MoveMachines.Tabs.SelectMachines.Selected', {count: selectedMachines.size})}
            </Typography>
        </Grid>
        <Machines organizationId={organizationId} actions={actions}/>
        <WizardNavigation {...props} onSubmitChange={onSubmitChange}/>
    </Fragment>
}
